/**
 * Nav Top
 */


 (function ($) {

    // set variables
    var $navTop = $('.js-nav-top'),
        hasSubContent = '.has-subcontent',
        subContentTrigger = '.js-nav-top__subcontent-trigger',
        activeClass = 'is-active',
        lastItemsClass = 'nav-top__item--right',
        subContentCloseDelay = 500;



    // nav items
    navItemsList = $navTop.find('> li');



    // last half of nav items
    $lastNavItems = navItemsList.slice(Math.floor(navItemsList.length/2));



    // add class to last half of nav items
    $lastNavItems.each(function( index, element ) {
        $( element ).addClass(lastItemsClass);
    });




    // click on subContentTrigger
    $navTop.find(hasSubContent).find(subContentTrigger).click(function( event ) {

      var $this = $(this);

      // disable default link action
      if ($this.is('a')) {
        event.preventDefault();
      }

      // disable subcontent of siblings
      $(this).closest(hasSubContent).siblings().removeClass(activeClass);

      // enable subcontent
      $(this).closest(hasSubContent).toggleClass(activeClass);

    });




    // disable subcontent on mouseleave
    var closeDropdownTimer;
    $navTop.find(hasSubContent)

      // disable subcontent after a delay
      .on('mouseleave', function() {

        var $this = $(this);

        // do not disable subcontent when input has :focus
        if($this.find('input').is(':focus')) {
          return false;
        }

        // check for data-delay attribute
        if ($(this).data('delay')) {
          // use data-delay as delay value
          var closeSubContentDelay = $(this).data('delay');
        }
        else {
          // use default delay
          var closeSubContentDelay = subContentCloseDelay;
        }

        closeDropdownTimer = setTimeout(function(){
            $(hasSubContent).removeClass(activeClass);
        },closeSubContentDelay)

      })

      // reset subcontent hiding when reentering dropdown
      .on('mouseenter', function() {
        clearTimeout(closeDropdownTimer);
      });




    // disable subcontent when click anywhere else
    // https://css-tricks.com/dangers-stopping-event-propagation/
    $(document).on('click', function(event) {
      if (!$(event.target).closest(hasSubContent + '.' + activeClass).length) {

        // disable subcontent
        $(hasSubContent).removeClass(activeClass);

      }
    });

 })(jQuery);
